import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload } from './utils'

export const getDirectorAudit = (id, projectversionId) => {
  const url = `${API_ROOT}/v1/audit/ia/get?id=${id}&projectversionId=${projectversionId}`
  return doGet(url)
}

export const saveDraftDirectorAudit = (request, id = '', isSaveDraft = false) => {
  const url = `${API_ROOT}/v1/audit/ia/approver/${id}?saveDraft=${isSaveDraft}`
  return doPut(url, request)
}
